// src/menu/sections/authMenu.ts
import type { AppMenuEntry } from "../types";

export const AUTH_MENU: AppMenuEntry = {
  type: "group",
  key: "Auth",
  label: "Auth Credentials",
  children: [
    /*
    {
      key: "credentials_safe",
      label: "Credentials Safe",
      path: "/credentials_safe",
      resource: "credentials_safe",
      icon: "auth",
    },
*/
    {
      key: "credentials",
      label: "Credentials",
      path: "/credentials",
      resource: "credentials_safe",
      icon: "keyoutlined",
    },
    {
      key: "v_keystore_passwords_safe",
      label: "Keystore Credentials",
      path: "/v_keystore_passwords_safe",
      resource: "v_keystore_passwords_safe",
      icon: "key",
    },
  ],
};
